import { render, staticRenderFns } from "./Recuperador.vue?vue&type=template&id=23f9f875&"
import script from "./Recuperador.vue?vue&type=script&lang=js&"
export * from "./Recuperador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports